var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router';
import { HandshakePainterServiceApiV1 } from 'src/api/handshakeApi';
import { PlacementType } from '@amzn/handshake-painter-typescript-client/v1';
import { useDefaultApiParams } from './useDefaultApiParams';
/**
 * Custom hook to fetch product widget data based on ASINs from URL parameters.
 */
export const useProductWidget = ({ enabled }) => {
    var _a;
    const [searchParams] = useSearchParams();
    const { getDefaultParams } = useDefaultApiParams();
    const asins = ((_a = searchParams.get('asins')) === null || _a === void 0 ? void 0 : _a.split(',').filter(Boolean)) || [];
    return useQuery({
        queryKey: ['getProductWidget', asins],
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            const defaultApiParams = getDefaultParams();
            return yield HandshakePainterServiceApiV1.getProductWidget({
                asins,
                placement: PlacementType.CustomersAlsoBought,
                xUserLinked: defaultApiParams.xUserLinked,
                xJoinId: defaultApiParams.xJoinId,
                marketplaceId: defaultApiParams.marketplaceId,
            });
        }),
        enabled: enabled && asins.length >= 3,
    });
};
